// src/index.ts
import { createPublicClient, createWalletClient, custom } from "viem";
import {
  chainConfig as opChainConfig,
  publicActionsL2,
  walletActionsL1,
  walletActionsL2,
  publicActionsL1
} from "viem/op-stack";
import { chainConfig as celoChainConfig } from "viem/celo";
import { chainConfig as zksyncChainConfig, eip712WalletActions } from "viem/zksync";

// src/actions/getL1BaseFee.ts
import { getChainContractAddress } from "viem/utils";
import { chainConfig } from "viem/op-stack";
var contracts = chainConfig.contracts;
var gasPriceOracleAbi = [
  {
    inputs: [],
    name: "l1BaseFee",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  }
];
async function getL1BaseFee(client, args) {
  const { chain = client.chain, gasPriceOracleAddress: gasPriceOracleAddress_ } = args || {};
  const gasPriceOracleAddress = (() => {
    if (gasPriceOracleAddress_)
      return gasPriceOracleAddress_;
    if (chain)
      return getChainContractAddress({
        chain,
        contract: "gasPriceOracle"
      });
    return contracts.gasPriceOracle.address;
  })();
  return client.readContract({
    abi: gasPriceOracleAbi,
    address: gasPriceOracleAddress,
    functionName: "l1BaseFee"
  });
}

// src/actions/getL1FeeScalar.ts
import { getChainContractAddress as getChainContractAddress2 } from "viem/utils";
import { chainConfig as chainConfig2 } from "viem/op-stack";
var contracts2 = chainConfig2.contracts;
var gasPriceOracleAbi2 = [
  {
    inputs: [],
    name: "scalar",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  }
];
async function getL1FeeScalar(client, args) {
  const { chain = client.chain, gasPriceOracleAddress: gasPriceOracleAddress_ } = args || {};
  const gasPriceOracleAddress = (() => {
    if (gasPriceOracleAddress_)
      return gasPriceOracleAddress_;
    if (chain)
      return getChainContractAddress2({
        chain,
        contract: "gasPriceOracle"
      });
    return contracts2.gasPriceOracle.address;
  })();
  return client.readContract({
    abi: gasPriceOracleAbi2,
    address: gasPriceOracleAddress,
    functionName: "scalar"
  });
}

// src/actions/index.ts
function extraActions() {
  return (client) => {
    return {
      getL1BaseFee: (args) => getL1BaseFee(client, args),
      getL1FeeScalar: (args) => getL1FeeScalar(client, args)
    };
  };
}

// src/index.ts
function fromChainInfoToChain(chainInfo) {
  switch (chainInfo.chainType) {
    case "op-stack":
      return { ...opChainConfig, ...chainInfo };
    case "celo":
      return { ...celoChainConfig, ...chainInfo };
    case "zksync":
      return { ...zksyncChainConfig, ...chainInfo };
    default:
      return {
        ...chainInfo
      };
  }
}
function createViemPublicClient({
  chainInfo,
  connection,
  providerOverride
}) {
  const transport = custom(providerOverride ? providerOverride : connection.provider);
  const chain = fromChainInfoToChain(chainInfo);
  let publicClient = createPublicClient({ transport, chain });
  let opPublicClient;
  if (chainInfo.chainType === "op-stack") {
    opPublicClient = publicClient.extend(publicActionsL2()).extend(publicActionsL1()).extend(extraActions());
    publicClient = opPublicClient;
  }
  return opPublicClient || publicClient;
}
function createViemWalletClient({
  chainInfo,
  account,
  connection,
  providerOverride
}) {
  const transport = custom(providerOverride ? providerOverride : connection.provider);
  const chain = fromChainInfoToChain(chainInfo);
  const viemAccount = {
    address: account.address,
    type: "json-rpc"
  };
  let walletClient = createWalletClient({
    transport,
    account: viemAccount,
    chain
  });
  let opWalletClient;
  if (chainInfo.chainType === "op-stack") {
    opWalletClient = walletClient.extend(walletActionsL2()).extend(walletActionsL1());
    walletClient = opWalletClient;
  }
  let zksyncWalletClient;
  if (chainInfo.chainType === "zksync") {
    zksyncWalletClient = walletClient.extend(eip712WalletActions());
    walletClient = zksyncWalletClient;
  }
  return opWalletClient || zksyncWalletClient || walletClient;
}
function viemify({
  connection,
  account,
  network,
  providerOverride
}) {
  let publicClient = createViemPublicClient({
    chainInfo: network.chainInfo,
    connection,
    providerOverride
  });
  let walletClient = createViemWalletClient({
    chainInfo: network.chainInfo,
    account,
    connection,
    providerOverride
  });
  const client = { wallet: walletClient, public: publicClient };
  return {
    connection,
    account,
    network,
    client
  };
}
function initViemClientExecution(execute) {
  return {
    execute(callback) {
      return execute(async ({ connection, network, account }) => {
        const viemified = viemify({
          connection,
          network,
          account
        });
        return callback(viemified);
      });
    }
  };
}
export {
  createViemPublicClient,
  createViemWalletClient,
  fromChainInfoToChain,
  initViemClientExecution,
  viemify
};
//# sourceMappingURL=index.js.map